import { styled } from '@health-zelas/delta'

export const Wrapper = styled('div', {})
